import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowRight, Users, Wrench, ShieldCheck, Building2, Factory, Truck } from "lucide-react";

export default function ManufacturerAndVehicles() {
  const [mfrs, setMfrs] = useState([]);
  const [makes, setMakes] = useState([]);
  useEffect(() => {
    api.get("/products/facets").then(({ data }) => {
      setMfrs(data.manufacturers_with_count || []);
      setMakes(data.makes_with_count || []);
    });
  }, []);
  return (
    <>
      <section data-testid="home-manufacturers" className="bg-[#0B0F19] text-white py-16 lg:py-24 relative overflow-hidden">
        <div className="absolute inset-0 ici-grid-bg-dark opacity-30" />
        <div className="max-w-7xl mx-auto px-4 lg:px-8 relative">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
              <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#94A3B8]">Manufacturers</div>
              <h2 className="mt-2 font-heading text-3xl lg:text-4xl font-bold tracking-tight">Shop by manufacturer</h2>
              <p className="text-sm text-slate-400 mt-2 max-w-xl">Active brands in our current inventory.</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {mfrs.slice(0, 8).map((m, i) => (
              <Link
                key={m.name}
                to={`/shop?manufacturer=${encodeURIComponent(m.name)}`}
                data-testid={`manufacturer-${m.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                className="group border border-white/10 bg-white/5 hover:bg-white/10 backdrop-blur rounded-xl p-5 transition-all hover:border-[#0055FF]/60 ici-fade-up"
                style={{ animationDelay: `${i * 40}ms` }}
              >
                <div className="text-lg font-heading font-semibold text-white">{m.name}</div>
                <div className="text-xs font-mono text-slate-400 mt-1">{m.count} PRODUCT{m.count !== 1 ? "S" : ""}</div>
                <ArrowRight className="mt-4 w-4 h-4 text-slate-500 group-hover:text-[#0055FF] group-hover:translate-x-1 transition-all" />
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="home-vehicle-makes" className="bg-white py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
              <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#0055FF]">Vehicle makes</div>
              <h2 className="mt-2 font-heading text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">Shop by vehicle make</h2>
            </div>
            <Link to="/vehicle-finder" className="text-sm text-slate-600 hover:text-[#0055FF] inline-flex items-center gap-1">
              Vehicle finder <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {makes.slice(0, 18).map((m, i) => (
              <Link
                key={m.name}
                to={`/shop?make=${encodeURIComponent(m.name)}`}
                data-testid={`make-${m.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                className="group border border-slate-200 hover:border-[#0055FF] rounded-xl p-4 transition-all hover:shadow-lg hover:-translate-y-0.5 ici-fade-up"
                style={{ animationDelay: `${(i % 6) * 40}ms` }}
              >
                <div className="text-sm font-heading font-semibold text-slate-900">{m.name}</div>
                <div className="text-[10px] font-mono text-slate-400 mt-1">{m.count} PART{m.count !== 1 ? "S" : ""}</div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
